<template>
  <div id="app">
    <div class="my-home" v-if="loadingIndex" style="z-index: 99;">
        <div class="my-home__main">
            <img class="my-home__loading" src="../public/img/loading-spin.svg" alt="loading">
            <div class="my-home__title">
                努力加载中...
            </div>
            <div class="my-home__sub-title d">
                初次加载资源可能需要较多时间 请耐心等待
            </div>
        </div>
    </div>
    <router-view v-if="!loadingIndex"/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        loadingIndex:true
      };
    },
    watch: {},
    created() {
      let times = '500';// 加载延时loading
      let that = this;
      setTimeout(function(){
        that.loadingIndex = false;
      }, times);
    },
    methods: {},
    computed: {}
  };
</script>
<style>
/* element样式覆盖 */
/* .el-form-item__label {
  font-weight: bold;
} */
/**我的全局样式 */
.z-index-9999 {
  z-index: 9999!important;
}
.page-container {
  height: calc(100vh - 170px);
  padding: 25px;
  overflow: hidden;
  overflow-y: scroll;
  background-color: #fff;
}

@media screen and (max-width: 1200px) {
  .page-container {
    height: calc(100vh - 110px);
  }
}


#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue